<template>
  <div class="prize-board" v-if="bigPrizes">
    <div class="text-left">
      <em>{{ bigPrizes.text }}</em>
      <em>{{ bigPrizes.desc }}</em>
    </div>
    <div class="prize-list">
      <img v-for="(prize, index) in bigPrizes.prizeListImages" :key="index" :src="prize" />
    </div>
    <em @click="showPrizeList" class="text-right">详情</em>
  </div>
</template>
<script>
import { GAME_INFO } from "../configs"
import { computed } from "@vue/composition-api"
export default {
  props: ["map", "state", "send"],

  setup(props) {
    // 按照地图以及宝箱展示用户的奖池信息
    const showPrizeList = () => {
      props.send("FETCH_PRIZE_LIST", {
        rank: "1",
        showAll: true
      })
    }

    // 查询当前大奖图片信息
    const bigPrizes = computed(() => {
      return GAME_INFO.bigPrizes[props.map]
    })

    return {
      showPrizeList,
      bigPrizes
    }
  }
}
</script>
